import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import ImageGalleryCard from '../gallery/ImageGalleryCard';
import './SolarSection.css';

const SOLAR_HARVEST_IMAGES = [
  {
    src: '/images/solar/Phase 1 - Park Solar 1.jpeg',
    thumbnail: '/images/solar/Phase 1 - Park Solar 1.jpeg',
    title: 'Phase 1 - Park Solar 1',
  },
  {
    src: '/images/solar/Phase 1 - Park Solar 2.jpeg',
    thumbnail: '/images/solar/Phase 1 - Park Solar 2.jpeg',
    title: 'Phase 1 - Park Solar 2',
  },
  {
    src: '/images/solar/Phase 1 - Park Solar 3.jpeg',
    thumbnail: '/images/solar/Phase 1 - Park Solar 3.jpeg',
    title: 'Phase 1 - Park Solar 3',
  },
  {
    src: '/images/solar/Phase 1 - Park Solar 4.jpeg',
    thumbnail: '/images/solar/Phase 1 - Park Solar 4.jpeg',
    title: 'Phase 1 - Park Solar 4',
  },
  {
    src: '/images/solar/Phase 1 - Social infra - 1.jpeg',
    thumbnail: '/images/solar/Phase 1 - Social infra - 1.jpeg',
    title: 'Phase 1 - Social Infra 1',
  },
  {
    src: '/images/solar/Phase 1 - Social infra - 2.jpeg',
    thumbnail: '/images/solar/Phase 1 - Social infra - 2.jpeg',
    title: 'Phase 1 - Social Infra 2',
  },
];

const SolarSection = () => {
  const [showList, setShowList] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowList(true);
    }, 2000); // Animation starts after 2 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <section>
      <Container className="ps-0 pe-0">
        <h3 className="solar-title">Solar Energy</h3>
        <Row className="mt-3">
          {/* Text Content */}
          <Col xs={12} md={9}>
            <p>
              A solar project for Aparna Western Meadows can significantly
              reduce power bills by harnessing renewable energy, lowering
              dependence on traditional electricity sources. The system would be
              designed to meet current energy needs while being scalable for
              future expansion, ensuring additional panels can be added as
              demand grows. With minimal maintenance required—mostly periodic
              cleaning and inspections—the system offers long-term savings and
              reliability.
              <br />
              <br />
              By investing in solar energy, Aparna Western Meadows can cut
              energy costs, lower its carbon footprint, and promote
              sustainability. The ability to expand the system over time ensures
              that the community stays ahead of its energy needs while
              contributing to a cleaner, greener environment.
            </p>

            <div className="solar-services-content">
              <h5>Key Highlights</h5>
              <ul className="solar-list-quotes">
                <li className={showList ? 'solar-list-item' : ''}>
                  <span className="solar-icon"></span>Instaled on rooftops of
                  OHTs, Phase 1 Parks, Social Infrastructure.
                </li>
                <li className={showList ? 'solar-list-item' : ''}>
                  <span className="solar-icon"></span>Covered 60KWs of capacity.
                </li>
              </ul>
            </div>
          </Col>

          {/* Image Gallery */}
          <Col xs={12} md={3} className="mt-4 mt-md-0">
            <ImageGalleryCard
              images={SOLAR_HARVEST_IMAGES}
              footerText="Solar Energy"
              className="solar-image-gallery-card"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SolarSection;
